import { jsx as _jsx } from "react/jsx-runtime";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import { useEffect, useMemo, useState } from "react";
import tinytime from "tinytime";
import { isToday, isYesterday } from "@sprout/client-lib/dist/date";
import ActivityPageGroupsList from "./ActivityPageGroupsList";
import condition from "./condition";
import getGroupKeyFromActivity from "./getGroupKeyFromActivity";
import ActivityPageEmptyList from "./ActivityPage_EmptyList";
const time = tinytime("{MMMM} {DD}");
const getReadableDate = (date)=>{
    let result;
    if (isToday(date)) result = "Today";
    else if (isYesterday(date)) result = "Yesterday";
    else result = time.render(new Date(date));
    return result;
};
const getHeader = (currItem, ssr)=>{
    const { createdAt: currCreatedAt  } = currItem;
    return getReadableDate(ssr ? new Date(currCreatedAt).toISOString() : currCreatedAt);
};
const ActivityPageList = (props)=>{
    const { loadMore , hasNextPage , loading , activities: rawActivities , subject ,  } = props;
    const [mount, setMount] = useState(false);
    const currentUser = useCurrentUser();
    const activityGroups = useMemo(()=>{
        let currentGroup = null;
        const entries = [];
        const seenIds = new Set();
        for(let index = 0; index < rawActivities.length; index++){
            const activity = rawActivities[index];
            if (seenIds.has(activity.id)) {
                console.warn(`Duplicate id ${activity.id} found; skipping`);
                continue;
            }
            seenIds.add(activity.id);
            const result = condition(activity, currentUser);
            if (result === null) continue;
            const groupKey = getGroupKeyFromActivity(activity);
            if (groupKey === null || !currentGroup || currentGroup.key !== groupKey) {
                currentGroup = {
                    key: groupKey,
                    condition: result,
                    header: getHeader(activity, !mount),
                    activity,
                    moreActivities: []
                };
                entries.push(currentGroup);
            } else currentGroup.moreActivities.push(activity);
        }
        return entries;
    }, [
        rawActivities,
        currentUser,
        mount
    ]);
    useEffect(()=>{
        setMount(true);
    }, []);
    if (activityGroups.length === 0) return /*#__PURE__*/ _jsx(ActivityPageEmptyList, {});
    return /*#__PURE__*/ _jsx(ActivityPageGroupsList, {
        activityGroups: activityGroups,
        hasNextPage: !!hasNextPage,
        loadMore: loadMore,
        loading: loading,
        subject: subject
    });
};
export default ActivityPageList;
